import User from './src/pages/UserSaga/User';
import UserInventory from './src/pages/UserSaga/UserInventory';
import UserGoogleBilling from './src/pages/UserSaga/UserGoogleBilling';

const MenuUser = [
    {
        id: 'user',
        name: 'User',
        icon: 'icon-people',
        path: 'user',
        component: User,
        isShown: 1,
    },
    {
        id: 'UserInventory',
        name: 'User Inventory',
        icon: 'icon-organization',
        path: 'user-inventory',
        component: UserInventory,
        isShown: 1,
    },
    {
        id: 'UserGoogleBilling',
        name: 'User Google Billing',
        icon: 'icon-organization',
        path: 'user-google-billing',
        component: UserGoogleBilling,
        isShown: 1,
    },
];

export default MenuUser;
